/** animate on scroll */
import AOS from "aos";

$(function() {
  AOS.init({
    duration: 800,
      once:true,
      mirror:false,
  });
});

window.addEventListener("load", function () {
    AOS.refresh();
});



// WEBPACK FOOTER //
// ./scripts/autoload/aos.js